import React, {useEffect, useState} from "react";
import {UserRegister} from "@/entity/User";
import {me, update} from "@/api";
import Layout from "@/layout/Layout";
import ProfileEditor from "@/components/ProfileEditor";
import MButton from "@/components/atom/MButton";
import globalStyle from '@/styles/Global.scss'
import {useHistory} from "react-router";

const EditProfile = () => {
  const history = useHistory()
  const [userRegister, setUserRegister] = useState(new UserRegister({}))

  useEffect(() => {
    (async () => {
      const myData = await me();
      setUserRegister(new UserRegister(myData))
    })()
  }, [])

  const updateUserRegister = (diff) => {
    setUserRegister(new UserRegister({...userRegister, ...diff}))
  }

  const save = async () => {
    await update({user: userRegister})
    history.push(`/profile`)
  }

  const goBack = () => {
    history.push(`/profile`)
  }

  return (
    <>
      <Layout title={'プロフィールの編集'}>
        <div>
          <ProfileEditor userRegister={userRegister} onChange={updateUserRegister}></ProfileEditor>
        </div>
        <div className={globalStyle.attribute}>
          <MButton image={'touroku.png'} value={'登録'} onClick={save}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default EditProfile
